import {combineReducers} from "redux";
import namespaceReducer from "./namespace_reducer"

export default combineReducers({
    namespaces: namespaceReducer,
});